<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : '检验'"
      width="1200px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="inspection"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="编号" prop="billNo">
            <el-input v-model="inspection.billNo" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="inspection.relBillNo" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col v-if="inspection.status === 1" :span="12">
          <el-form-item label="检验人" prop="inspectorName">
            <el-input v-model="inspection.inspectorName" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col v-if="inspection.status === 1" :span="12">
          <el-form-item label="检验日期" prop="documentDate">
            <el-date-picker
                v-model="inspection.documentDate"
                type="date"
                :disabled="true"
                style="width: 100%"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker
                v-model="inspection.createTime"
                type="datetime"
                :disabled="true"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="note">
            <el-input v-model="inspection.note" type="textarea" placeholder="请输入" autosize/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">检验明细</div>
      <Table border stripe :columns="columns" :data="inspection.details">
        <template slot="procScrapQty" slot-scope="{ row, index }">
          <el-input-number v-model="row.procScrapQty" style="width: 100%" :min="0" @change="$set(inspection.details, index, row)"/>
        </template>
        <template slot="mtrlScrapQty" slot-scope="{ row, index }">
          <el-input-number v-model="row.mtrlScrapQty" style="width: 100%" :min="0" @change="$set(inspection.details, index, row)"/>
        </template>
        <template slot="repairQty" slot-scope="{ row, index }">
          <el-input-number v-model="row.repairQty" style="width: 100%" :min="0" @change="$set(inspection.details, index, row)"/>
        </template>
        <template slot="note" slot-scope="{ row, index }">
          <el-input
              v-model="row.note"
              type="textarea"
              placeholder="请输入"
              autosize
              @change="$set(inspection.details, index, row)"/>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        inspection: {
          billNo: "",
          status: "",
          relBillNo: "",
          inspectorName: "",
          documentDate: "",
          createTime: "",
          note: "",
        },
        columns: [
          {
            title: "物料编号",
            key: "materialNo",
            width: 120,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 240,
            tooltip: true,
          },
          {
            title: "检验数量",
            width: 110,
            align: "center",
            key: "inspectQty",
          },
          {
            title: "合格数量",
            width: 110,
            align: "center",
            key: "qualifiedQty",
          },
          {
            title: "不合格数量",
            width: 110,
            align: "center",
            key: "unqualifiedQty",
          },
          {
            title: "工废数量",
            width: 140,
            align: "center",
            slot: "procScrapQty",
          },
          {
            title: "料废数量",
            width: 140,
            align: "center",
            slot: "mtrlScrapQty",
          },
          {
            title: "返修数量",
            width: 140,
            align: "center",
            slot: "repairQty",
          },
          {
            title: "描述",
            width: 240,
            slot: "note",
          },
        ],
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          console.log(row);
          this.getData(row.pkId);
        }
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionBills/${id}`)
          .then((resp) => {
            if (resp.success) {
              resp.data.details.forEach(item => {
                if (item.qualifiedQty === null) {
                  item.qualifiedQty = 0;
                }
                if (item.unqualifiedQty === null) {
                  item.unqualifiedQty = 0;
                }
              });
              this.inspection = Object.assign(this.inspection, resp.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "inspectionBills", this.inspection)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("检验成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
